import { render, staticRenderFns } from "./AmetrasAttachmentTemplate.vue?vue&type=template&id=fa74dc0e&scoped=true&"
import script from "./AmetrasAttachmentTemplate.vue?vue&type=script&lang=ts&"
export * from "./AmetrasAttachmentTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./AmetrasAttachmentTemplate.vue?vue&type=style&index=0&id=fa74dc0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa74dc0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VRow})
